/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './delete-action.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../app/multi-editor/delete-action/delete-action.component';
import * as i4 from '../autocomplete-input/autocomplete-input.component.ngfactory';
import * as i5 from '../../../../app/multi-editor/autocomplete-input/autocomplete-input.component';
import * as i6 from '../../../../app/multi-editor/shared/services/schema-keys-store.service';
import * as i7 from '@angular/common';
const styles_DeleteActionComponent:any[] = [i0.styles];
export const RenderType_DeleteActionComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_DeleteActionComponent,data:{}});
function View_DeleteActionComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'option',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(1,
      147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,i1.Renderer2,[2,i2.SelectControlValueAccessor]],
      {ngValue:[0,'ngValue']},(null as any)),i1.ɵdid(2,147456,(null as any),0,i2.ɵq,
      [i1.ElementRef,i1.Renderer2,[8,(null as any)]],{ngValue:[0,'ngValue']},(null as any)),
      (_l()(),i1.ɵted(3,(null as any),[' ',' ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_2);
  });
}
export function View_DeleteActionComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),42,'form',[['class',
      'form-inline'],['novalidate','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'submit'],[(null as any),'reset']],(_v,en,
      $event) => {
    var ad:boolean = true;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i2.ɵbf,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(2,16384,(null as any),0,i2.NgForm,[[8,(null as any)],
      [8,(null as any)]],(null as any),(null as any)),i1.ɵprd(2048,(null as any),i2.ControlContainer,
      (null as any),[i2.NgForm]),i1.ɵdid(4,16384,(null as any),0,i2.NgControlStatusGroup,
      [i2.ControlContainer],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵeld(6,0,(null as any),(null as any),1,'label',[['class',
      'form-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['Field:'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  '])),(_l()(),i1.ɵeld(9,0,(null as any),(null as any),5,'div',[['class',
          'form-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(11,0,(null as any),
          (null as any),2,'re-autocomplete-input',[['name','key'],['placeholder','field key'],
              ['type','text']],(null as any),[[(null as any),'valueChange']],(_v,en,
              $event) => {
            var ad:boolean = true;
            var _co:i3.DeleteActionComponent = _v.component;
            if (('valueChange' === en)) {
              const pd_0:any = ((<any>(_co.action.mainKey = $event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_AutocompleteInputComponent_0,i4.RenderType_AutocompleteInputComponent)),
      i1.ɵdid(12,49152,(null as any),0,i5.AutocompleteInputComponent,[i6.SchemaKeysStoreService],
          {placeholder:[0,'placeholder']},{valueChange:'valueChange'}),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
          i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(16,0,(null as any),(null as any),
          1,'span',[['class','form-group']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['when value'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(19,0,(null as any),
          (null as any),12,'div',[['class','form-group']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵeld(21,0,(null as any),(null as any),9,'select',
          [['class','form-control input-sm'],['name','matchType']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
              [(null as any),'change'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.DeleteActionComponent = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,22).onChange($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,22).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.action.matchType = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(22,16384,(null as any),0,i2.SelectControlValueAccessor,
          [i1.Renderer2,i1.ElementRef],(null as any),(null as any)),i1.ɵprd(1024,(null as any),
          i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i2.SelectControlValueAccessor]),i1.ɵdid(24,671744,(null as any),0,i2.NgModel,
          [[2,i2.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(26,16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_DeleteActionComponent_1)),i1.ɵdid(29,
          802816,(null as any),0,i7.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(33,0,(null as any),(null as any),
          8,'div',[['class','form-group']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(35,0,(null as any),(null as any),5,'input',[['class','form-control input-sm'],
          ['name','value'],['placeholder','value to delete'],['type','text']],[[2,
          'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
          (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
          [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
          'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
          'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.DeleteActionComponent = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,36)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,36).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,36)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,36)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_4:any = ((<any>(_co.action.updateValue = $event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(36,16384,(null as any),0,i2.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i1.ɵdid(38,671744,(null as any),0,i2.NgModel,[[2,
          i2.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(40,16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i3.DeleteActionComponent = _v.component;
    const currVal_7:any = 'field key';
    _ck(_v,12,0,currVal_7);
    const currVal_15:any = 'matchType';
    const currVal_16:any = _co.action.matchType;
    _ck(_v,24,0,currVal_15,currVal_16);
    const currVal_17:any = _co.matchTypes;
    _ck(_v,29,0,currVal_17);
    const currVal_25:any = 'value';
    const currVal_26:any = _co.action.updateValue;
    _ck(_v,38,0,currVal_25,currVal_26);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,4).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,4).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,4).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,4).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,4).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,4).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,4).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = i1.ɵnov(_v,26).ngClassUntouched;
    const currVal_9:any = i1.ɵnov(_v,26).ngClassTouched;
    const currVal_10:any = i1.ɵnov(_v,26).ngClassPristine;
    const currVal_11:any = i1.ɵnov(_v,26).ngClassDirty;
    const currVal_12:any = i1.ɵnov(_v,26).ngClassValid;
    const currVal_13:any = i1.ɵnov(_v,26).ngClassInvalid;
    const currVal_14:any = i1.ɵnov(_v,26).ngClassPending;
    _ck(_v,21,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_18:any = i1.ɵnov(_v,40).ngClassUntouched;
    const currVal_19:any = i1.ɵnov(_v,40).ngClassTouched;
    const currVal_20:any = i1.ɵnov(_v,40).ngClassPristine;
    const currVal_21:any = i1.ɵnov(_v,40).ngClassDirty;
    const currVal_22:any = i1.ɵnov(_v,40).ngClassValid;
    const currVal_23:any = i1.ɵnov(_v,40).ngClassInvalid;
    const currVal_24:any = i1.ɵnov(_v,40).ngClassPending;
    _ck(_v,35,0,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,
        currVal_24);
  });
}
export function View_DeleteActionComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-delete-action',
      ([] as any[]),(null as any),(null as any),(null as any),View_DeleteActionComponent_0,
      RenderType_DeleteActionComponent)),i1.ɵdid(1,49152,(null as any),0,i3.DeleteActionComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const DeleteActionComponentNgFactory:i1.ComponentFactory<i3.DeleteActionComponent> = i1.ɵccf('re-delete-action',
    i3.DeleteActionComponent,View_DeleteActionComponent_Host_0,{action:'action'},{},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/delete-action/delete-action.component.ngfactory.ts